import React from 'react';

function EmailIcon(props) {
    return (
        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.1667 0.916668H4.83335C2.33335 0.916668 0.666687 2.16667 0.666687 5.08333V10.9167C0.666687 13.8333 2.33335 15.0833 4.83335 15.0833H13.1667C15.6667 15.0833 17.3334 13.8333 17.3334 10.9167V5.08333C17.3334 2.16667 15.6667 0.916668 13.1667 0.916668ZM13.5584 5.99167L10.95 8.075C10.4 8.51667 9.70002 8.73334 9.00002 8.73334C8.30002 8.73334 7.59169 8.51667 7.05002 8.075L4.44169 5.99167C4.17502 5.775 4.13335 5.375 4.34169 5.10834C4.55835 4.84167 4.95002 4.79167 5.21669 5.00834L7.82502 7.09167C8.45835 7.6 9.53335 7.6 10.1667 7.09167L12.775 5.00834C13.0417 4.79167 13.4417 4.83333 13.65 5.10834C13.8667 5.375 13.825 5.775 13.5584 5.99167Z"
                fill="#37C26F"/>
        </svg>
    );
}

export default EmailIcon;
